export enum VppsActionTypes {
    GET_VPPS = "[App Action][Vpps] GET VPPS",
    GET_VPPS_SUCCESS = "[App Action][Vpps] GET VPPS SUCCESS",
    GET_VPPS_FAIL = "[App Action][Vpps] GET VPPS FAIL",

    GET_VPPS_USERS = "[App Action][Vpps] GET VPPS USERS",
    GET_VPPS_USERS_SUCCESS = "[App Action][Vpps] GET VPPS USERS SUCCESS",
    GET_VPPS_USERS_FAIL = "[App Action][Vpps] GET VPPS USERS FAIL",

    CREATE_VPP = "[App Action][Vpps] CREATE VPP",
    CREATE_VPP_SUCCESS = "[App Action][Vpps] CREATE VPP SUCCESS",
    CREATE_VPP_FAIL = "[App Action][Vpps] CREATE VPP FAIL",
    CREATE_VPP_RESET = "[App Action][Vpps] CREATE VPP RESET",

    CREATION_MODE_CHANGE = "[App Action][Vpps] CREATION MODE CHANGE",
    UPDATE_CREATING_VPP = "[App Action][Vpps] UPDATE CREATING VPP",

    GET_SUBSIDIARIES = "[App Action][Vpps] GET SUBSIDIARIES",
    GET_SUBSIDIARIES_SUCCESS = "[App Action][Vpps] GET SUBSIDIARIES SUCCESS",
    GET_SUBSIDIARIES_FAIL = "[App Action][Vpps] GET SUBSIDIARIES FAIL",

    DELETE_VPP = "[App Action][Vpps] DELETE VPP",
    DELETE_VPP_SUCCESS = "[App Action][Vpps] DELETE VPP SUCCESS",
    DELETE_VPP_FAIL = "[App Action][Vpps] DELETE VPP FAIL"
}
